module.exports = __webpack_public_path__ + "static/5-8b763220218ffc11c57c84ddb80e7b26.woff";